import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Terminal } from 'src/app/interfaces/terminal';

@Injectable({
  providedIn: 'root'
})
export class EventService {

  constructor(private api: ApiService) { }

  checkGuest(accessId: string, phone: string) {
    return this.api.post('event/guest', { a: accessId, p: phone }, {}, 'apiV2');
  }

  checkCoupon(acc: string, assoc?: string, agent?: string, pa?: string) {
    return this.api.post('coupon', { acc, assoc, agent, pa }, {}, 'apiV2');
  }

  checkCouponGuest(a: string,  agent?: string, p?: string) {
    return this.api.post('coupon/contact', { a, agent, p }, {}, 'apiV2');
  }

  checkTicket(accessId: string) {
    return this.api.post('parking/ticket', { a: accessId }, {}, 'apiV2');
  }

  parkingClientButton(accessId: string) {
    return this.api.post('event/guest/button', { a: accessId, t: 'parking' }, {}, 'apiV2');
  }

  guestOpenRelay(access: string, terminal: Terminal, id: string, guest: string) {
    return this.api.post('event/guest/open', { a: access, t: terminal.id, r: id, g: guest }, {}, 'apiV2');
  }

  ticketOpenRelay(accessId: string, terminal: Terminal, id: string) {
  //  // console.log(accessId, terminal.id, id);
    return this.api.post('parking/client/open', { a: accessId, t: terminal.id, r: id }, {}, 'apiV2');
  }

  guestButton(accessId: string, guest: string) {
  //  // console.log({ a: accessId, g: guest });
    return this.api.post('event/guest/button', { a: accessId, g: guest }, {}, 'apiV2');
  }


  // Notifications

  /**
   * // Create and send the help center response by push notification to the user.
   * @param userId ID User {string}
   */
  sendNotifyReply(userId: string, ticketId ?: string) {
    return this.api.post('notify/reply/user', {u: userId, t: ticketId}, {}, 'apiV2');
  }


}
